export default {
  gap: 'fluidMedium',
  selectorPanelMaxWidth: '508px',
  speciesSelectionErrorMessage: false,
};
